import Swal from 'sweetalert2';

// Helpers para mensajes Swal consistentes y más profesionales.
export const confirmAction = ({
  title,
  text,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  icon = 'warning',
  confirmButtonColor = '#dc2626',
} = {}) =>
  Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor,
  });

export const showSuccess = (title, text) =>
  Swal.fire({
    title,
    text,
    icon: 'success',
    confirmButtonText: 'Listo',
  });

export const showError = (title, text) =>
  Swal.fire({
    title,
    text,
    icon: 'error',
    confirmButtonText: 'Cerrar',
  });
